import React from 'react'
import { ReactComponent as VerticalDots } from 'bootstrap-icons/icons/three-dots-vertical.svg'
import { DropdownToggleProps } from 'react-bootstrap/esm/DropdownToggle'

const VerticalDotDropdownToggle = React.forwardRef<HTMLButtonElement>(
    ({ children, onClick, className }: DropdownToggleProps, ref) => {
        className = className?.replace('dropdown-toggle', '')
        return (
            <button
                className={`btn btn-link ${className}`}
                ref={ref}
                onClick={(e) => {
                    e.preventDefault()
                    if (onClick === undefined) return
                    onClick(e)
                }}
                aria-label="Three Vertical Dots">
                {children}
                <VerticalDots width="22" height="22" />
            </button>
        )
    }
)

export default VerticalDotDropdownToggle
